module.exports = __webpack_public_path__ + "img/cyanTopBg.b43c418c.png";